import * as React from "react";
import { Dimmer } from "semantic-ui-react";
import Table from "../../components/Table/Table";
import { editActions } from "../../actions/editActions";
import EditDriveVersion from "../../containers/Editing/EditDriveVersion";
import { Filter } from "../../components/Table/Migration/LegacyTypes";
import * as _ from "lodash";

export type DriveVersionProps = {
  columns: State.ColumnMap;
  mainState: State.Main;
  editedObjectId: number | undefined;
  isEditActive: boolean;
  objectIdentifier: string;
  toggleModal: () => void;
  rows: Api.DriveVersion[];
  editActions: typeof editActions;
  subMenuRoute: State.DriveBindingsSubmenu;
  columnFilters?: Filter[];
  setColumnFilters: (subMenuRoute: State.DriveBindingsSubmenu, columnFilter: Filter[]) => void;
};

// Container for listing drive versions in a table
export class DriveVersions extends React.Component<DriveVersionProps> {

  componentDidMount(): void {
    // make throttle function
    this.handleFilterChangeDebounced = _.debounce(this.handleFilterChangeDebounced, 500);
  }

  private handleFilterChangeDebounced = (changedFilters: Filter[]) => {
    this.props.setColumnFilters(this.props.subMenuRoute, changedFilters);
  };

  render(): JSX.Element {
    const { columns, mainState, isEditActive, rows } = this.props;
    const { editSize, pageSize, isShortenTextEnabled } = mainState;

    const selectedColumns: State.Column[] = columns["Drive Versions"];

    return (
      <div className="table-container">
        <div className="flex-1">
          <div className="flex-1">
            <Table
              rows={rows}
              columns={selectedColumns}
              isHidingTextActive={isShortenTextEnabled}
              handleRowSelection={this.props.editActions.select}
              isRowSelected={this.isSelected}
              pageSize={pageSize}
              handleFilterChange={this.handleFilterChangeDebounced}
            />
          </div>
          {isEditActive && (
            <Dimmer active={true} page={true}>
              <div className="edit-view" style={{ flex: editSize , width : editSize == 0.3 ? "500px" : "1000px" }}>
                <EditDriveVersion toggleModal={this.props.toggleModal} />
              </div>
            </Dimmer>
          )}
        </div>
      </div>
    );
  }

  private isSelected = (driveVersion: Api.DriveVersion): boolean => {
    const { editedObjectId } = this.props;
    if (editedObjectId && driveVersion.id === editedObjectId) {
      return true;
    } else {
      return false;
    }
  };
}

export default DriveVersions;
